'use client';

import { Phone, Mail, MapPin } from 'lucide-react';
import { INDIA_OUTLINE_PATH, projectToSvg } from './hotels.data';
import { useTranslation } from '@/core/i18n';

interface HotelContactMapProps {
  hotel: {
    name: string;
    phone?: string;
    email?: string;
    address?: string;
    latitude: number;
    longitude: number;
  };
}

export function HotelDetailContactMap({ hotel }: HotelContactMapProps) {
  const { t } = useTranslation();
  const pin = projectToSvg(hotel.latitude, hotel.longitude);

  return (
    <>
      {/* Contact Info */}
      <div id="hotels-detail-contact" className="space-y-4">
        <h2 className="text-lg font-semibold text-hms-text">{t('maintenancePage.vendorContact')}</h2>
        <div className="rounded-xl border border-hms-border bg-hms-card p-5 space-y-3">
          {hotel.phone && (
            <div className="flex items-center gap-3">
              <Phone size={15} className="shrink-0 text-hms-gold" />
              <span id="hotels-detail-contact-phone" className="text-sm text-hms-textSub">{hotel.phone}</span>
            </div>
          )}
          {hotel.email && (
            <div className="flex items-center gap-3">
              <Mail size={15} className="shrink-0 text-hms-gold" />
              <span id="hotels-detail-contact-email" className="text-sm text-hms-textSub">{hotel.email}</span>
            </div>
          )}
          {hotel.address && (
            <div className="flex items-center gap-3">
              <MapPin size={15} className="shrink-0 text-hms-gold" />
              <span className="text-sm text-hms-textSub">{hotel.address}</span>
            </div>
          )}
        </div>
      </div>

      <hr className="border-hms-border" />

      {/* Mini Map */}
      <div id="hotels-detail-map" className="space-y-4">
        <h2 className="text-lg font-semibold text-hms-text">{t('maintenancePage.location')}</h2>
        <div className="rounded-xl border border-hms-border bg-hms-card p-4 overflow-hidden">
          <svg viewBox="0 0 1000 562" className="w-full h-auto max-h-48">
            <path d={INDIA_OUTLINE_PATH} fill="#182B44" fillOpacity="0.3" stroke="#182B44" strokeWidth="2" />
            <circle id="hotels-detail-map-pin" cx={pin.x} cy={pin.y} r="8" fill="#C8913A" stroke="#06080F" strokeWidth="2" />
            <text x={pin.x} y={pin.y - 14} textAnchor="middle" className="fill-hms-gold text-[14px] font-semibold">{hotel.name}</text>
          </svg>
        </div>
      </div>
    </>
  );
}
